webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueTouch = __webpack_require__(117);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _App = __webpack_require__(115);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(62);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueTouch2.default);
	
	_vue2.default.directive('focus', {
	  bind: function bind() {
	    var object = this.el;
	    _vue2.default.nextTick(function () {
	      object.focus();
	    });
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  store: _store2.default,
	  components: { App: _App2.default }
	});

/***/ },

/***/ 16:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANGE_MAP = exports.CHANGE_MAP = 'CHANGE_MAP';
	var CREATE_PLAYER = exports.CREATE_PLAYER = 'CREATE_PLAYER';
	var UPDATE_PLAYER = exports.UPDATE_PLAYER = 'UPDATE_PLAYER';
	var DELETE_PLAYER = exports.DELETE_PLAYER = 'DELETE_PLAYER';
	var CREATE_BOT = exports.CREATE_BOT = 'CREATE_BOT';
	var DELETE_BOT = exports.DELETE_BOT = 'DELETE_BOT';
	var ADD_PLAYER_TO_ROOM = exports.ADD_PLAYER_TO_ROOM = 'ADD_PLAYER_TO_ROOM';
	var REMOVE_PLAYER_FROM_ROOM = exports.REMOVE_PLAYER_FROM_ROOM = 'REMOVE_PLAYER_FROM_ROOM';
	var SWAP_PLAYER = exports.SWAP_PLAYER = 'SWAP_PLAYER';
	var SHUFFLE_PLAYER = exports.SHUFFLE_PLAYER = 'SHUFFLE_PLAYER';

/***/ },

/***/ 36:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(41);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _DataStore = __webpack_require__(58);
	
	var _DataStore2 = _interopRequireDefault(_DataStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = new _DataStore2.default('shuffle-hots');
	
	exports.default = {
	  saveData: function saveData(data, resolve, reject) {
	    return new _promise2.default(function (resolve, reject) {
	      try {
	        resolve(store.save(data));
	      } catch (err) {
	        reject(err);
	      }
	    }).then(resolve).catch(reject);
	  },
	  loadData: function loadData(resolve, reject) {
	    return new _promise2.default(function (resolve, reject) {
	      try {
	        var result = store.load();
	        if (result === null) {
	          result = [];
	        }
	        resolve(result);
	      } catch (err) {
	        reject(err);
	      }
	    }).then(resolve).catch(reject);
	  }
	};

/***/ },

/***/ 37:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var map = [['Battlefield of Eternity', 1, { bg_class: 'map-battlefield-of-eternity' }], ['Blackheart\'s Bay', 1, { bg_class: 'map-blackheart-bay' }], ['Cursed Hollow', 1, { bg_class: 'map-cursed-hollow' }], ['Dragon Shire', 1, { bg_class: 'map-dragon-shire' }], ['Garden of Terror', 1, { bg_class: 'map-garden-of-terror' }], ['Haunted Mines', 1, { bg_class: 'map-haunted-mine' }], ['Infernal Shrines', 1, { bg_class: 'map-infernal-shrines' }], ['Sky Temple', 1, { bg_class: 'map-sky-temple' }], ['Tomb of the Spider Queen', 1, { bg_class: 'map-tomb-of-the-spider-queen' }], ['Towers of Doom', 1, { bg_class: 'map-tower-of-doom' }]];
	
	exports.default = map;

/***/ },

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.swapArrayElements = exports.deleteCookie = exports.readCookie = exports.bakeCookie = exports.shuffle = undefined;
	
	var _stringify = __webpack_require__(39);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shuffle = function shuffle(array) {
	  var currentIndex = array.length;
	  var temporaryValue;
	  var randomIndex;
	
	  while (currentIndex !== 0) {
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	};
	
	var swapArrayElements = function swapArrayElements(arr, indexA, indexB) {
	  var temp = arr[indexA];
	  arr[indexA] = arr[indexB];
	  arr[indexB] = temp;
	};
	
	function bakeCookie(name, value) {
	  var cookie = [name, '=', (0, _stringify2.default)(value), '; expires=Thu, 01-Jan-2299 00:00:01 GMT; domain=.', window.location.host.toString(), '; path=/;'].join('');
	  document.cookie = cookie;
	}
	function readCookie(name) {
	  var result = document.cookie.match(new RegExp(name + '=([^;]+)'));
	  result && (result = JSON.parse(result[1]));
	  return result;
	}
	function deleteCookie(name) {
	  document.cookie = [name, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain=.', window.location.host.toString()].join('');
	}
	
	exports.shuffle = shuffle;
	exports.bakeCookie = bakeCookie;
	exports.readCookie = readCookie;
	exports.deleteCookie = deleteCookie;
	exports.swapArrayElements = swapArrayElements;

/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(39);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(70);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(71);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataStore = function () {
	  function DataStore(key) {
	    (0, _classCallCheck3.default)(this, DataStore);
	
	    this.key = key;
	  }
	
	  (0, _createClass3.default)(DataStore, [{
	    key: 'load',
	    value: function load() {
	      var retrievedObject = window.localStorage.getItem(this.key);
	      if (typeof retrievedObject === 'string') {
	        return JSON.parse(retrievedObject);
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save(data) {
	      return window.localStorage.setItem(this.key, (0, _stringify2.default)(data));
	    }
	  }]);
	  return DataStore;
	}();
	
	exports.default = DataStore;

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(73);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WeightedList = function () {
	  function _WeightedList(initial) {
	    this.weights = {};
	    this.data = {};
	    this.length = 0;
	    this.hasData = false;
	
	    initial = typeof initial !== 'undefined' ? initial : [];
	
	    if (Array.isArray(initial)) {
	      for (var i = 0; i < initial.length; i++) {
	        this.push(initial[i]);
	      }
	    } else {
	      throw new Error('Unknown object "' + initial.toString() + '" passed to ' + 'WeightedList constructor! (Expected array or nothing)');
	    }
	  }
	
	  _WeightedList.prototype = {
	    push: function push(element) {
	      var key, weight, data;
	
	      if (Array.isArray(element)) {
	        key = element[0];
	        weight = element[1];
	        data = element[2];
	        if (typeof key === 'undefined') {
	          throw new Error('In WeightedList.push([ ... ]), need at least two elements');
	        } else if (typeof weight === 'undefined') {
	          throw new Error('In array passed to WeightedList.push([ ... ]), second ' + 'element is undefined!');
	        }
	      } else if ((typeof element === 'undefined' ? 'undefined' : (0, _typeof3.default)(element)) === 'object') {
	        key = element.key;
	        weight = element.weight;
	        data = element.data;
	        if (typeof key === 'undefined') {
	          throw new Error("In WeightedList.push({ ... }), no {'key': 'xyzzy'} pair found");
	        } else if (typeof weight === 'undefined') {
	          throw new Error('In array passed to WeightedList.push({ ... }), no ' + "{'weight': 42} pair found");
	        }
	      } else {
	        throw new Error('WeightedList.push() passed unknown type "' + (typeof element === 'undefined' ? 'undefined' : (0, _typeof3.default)(element)) + '", expected [key, weight] or {"key": k, "weight": w}');
	      }
	      return this._push_values(key, weight, data);
	    },
	
	    _push_values: function _push_values(key, weight, data) {
	
	      if (this.weights[key]) {
	        throw new Error('');
	      }
	      if ((typeof weight === 'undefined' ? 'undefined' : (0, _typeof3.default)(weight)) !== (0, _typeof3.default)(1)) {
	        throw new Error('Weight must be numeric (got ' + weight.toString() + ')');
	      }
	      if (weight <= 0) {
	        throw new Error('Weight must be >= 0 (got ' + weight + ')');
	      }
	
	      this.weights[key] = weight;
	
	      if (typeof data !== 'undefined') {
	        this.hasData = true;
	        this.data[key] = data;
	      }
	      this.length++;
	    },
	
	    addWeight: function addWeight(key, weight) {
	      this.weights[key] += weight;
	    },
	
	    peek: function peek(n, andRemove) {
	      if (typeof n === 'undefined') {
	        n = 1;
	      }
	      andRemove = !!andRemove;
	
	      if (this.length - n < 0) {
	        throw new Error('Stack underflow! Tried to retrieve ' + n + ' element' + (n === 1 ? '' : 's') + ' from a list of ' + this.length);
	      }
	
	      var heap = this._buildWeightedHeap();
	
	      var result = [];
	
	      for (var i = 0; i < n; i++) {
	        var key = heap.pop();
	
	        if (this.hasData) {
	          result.push({ key: key, data: this.data[key] });
	        } else {
	          result.push(key);
	        }
	        if (andRemove) {
	          delete this.weights[key];
	          delete this.data[key];
	          this.length--;
	        }
	      }
	      return result;
	    },
	
	    shuffle: function shuffle() {
	      return this.peek(this.length);
	    },
	
	    pop: function pop(n) {
	      return this.peek(n, true);
	    },
	
	    _buildWeightedHeap: function _buildWeightedHeap() {
	      var items = [];
	      for (var key in this.weights) {
	        if (this.weights.hasOwnProperty(key)) {
	          items.push([key, this.weights[key]]);
	        }
	      }
	
	      return new _WeightedHeap(items);
	    }
	  };
	
	  function _HeapNode(weight, value, total) {
	    this.weight = weight;
	    this.value = value;
	    this.total = total;
	  }
	
	  function _WeightedHeap(items) {
	    this.heap = [null];
	    for (var i = 0; i < items.length; i++) {
	      var weight = items[i][1];
	      var value = items[i][0];
	      this.heap.push(new _HeapNode(weight, value, weight));
	    }
	
	    for (i = this.heap.length - 1; i > 1; i--) {
	      this.heap[i >> 1].total += this.heap[i].total;
	    }
	  }
	
	  _WeightedHeap.prototype = {
	    pop: function pop() {
	      var gas = this.heap[1].total * Math.random();
	
	      var i = 1;
	
	      while (gas > this.heap[i].weight) {
	        gas -= this.heap[i].weight;
	        i <<= 1;
	        if (gas > this.heap[i].total) {
	          gas -= this.heap[i].total;
	          i++;
	        }
	      }
	
	      var value = this.heap[i].value;
	      var selectedWeight = this.heap[i].weight;
	
	      this.heap[i].weight = 0;
	      while (i > 0) {
	        this.heap[i].total -= selectedWeight;
	        i >>= 1;
	      }
	      return value;
	    }
	  };
	
	  return _WeightedList;
	}();
	
	exports.default = WeightedList;

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.swapPlayer = exports.shuffleInLobby = exports.movePlayerToPending = exports.movePlayerToLobby = exports.removeBotFromLobby = exports.addBotToLobby = exports.deletePlayer = exports.addNewPlayer = exports.shuffleMap = undefined;
	
	var _promise = __webpack_require__(41);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _map = __webpack_require__(37);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _WeightedList = __webpack_require__(59);
	
	var _WeightedList2 = _interopRequireDefault(_WeightedList);
	
	var _player = __webpack_require__(36);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shuffleMap = exports.shuffleMap = function shuffleMap(_ref) {
	  var commit = _ref.commit;
	
	  var mapList = new _WeightedList2.default(_map2.default);
	  var picked = mapList.peek();
	  commit(types.CHANGE_MAP, {
	    className: picked[0].data.bg_class,
	    text: picked[0].key
	  });
	};
	
	var addNewPlayer = exports.addNewPlayer = function addNewPlayer(_ref2, player) {
	  var commit = _ref2.commit,
	      state = _ref2.state;
	
	  return new _promise2.default(function (resolve, reject) {
	    for (var index in state.player.list) {
	      var p = state.player.list[index];
	      if (p.name === player) {
	        return reject();
	      }
	    }
	    commit(types.CREATE_PLAYER, {
	      name: player
	    });
	    commit(types.ADD_PLAYER_TO_ROOM, {
	      name: player,
	      room: 'pending'
	    });
	
	    var playerData = [];
	    for (var _index in state.player.list) {
	      var _p = state.player.list[_index];
	      if (_p.data.type === 'human') {
	        playerData.push(_p.name);
	      }
	    }
	    _player2.default.saveData(playerData, function () {}, function () {});
	
	    return resolve();
	  });
	};
	
	var deletePlayer = exports.deletePlayer = function deletePlayer(_ref3, player) {
	  var commit = _ref3.commit,
	      state = _ref3.state;
	
	  return new _promise2.default(function (resolve, reject) {
	    for (var index in state.room.lobby) {
	      var p = state.player.list[index];
	      if (p.name === player) {
	        return reject();
	      }
	    }
	    commit(types.REMOVE_PLAYER_FROM_ROOM, {
	      name: player,
	      room: 'pending'
	    });
	    commit(types.DELETE_PLAYER, {
	      name: player
	    });
	    return resolve();
	  });
	};
	
	var addBotToLobby = exports.addBotToLobby = function addBotToLobby(_ref4) {
	  var commit = _ref4.commit,
	      state = _ref4.state;
	
	  return new _promise2.default(function (resolve, reject) {
	    if (state.player.hasBot) {
	      return reject();
	    }
	    commit(types.CREATE_BOT);
	    commit(types.ADD_PLAYER_TO_ROOM, {
	      name: 'bot',
	      room: 'lobby'
	    });
	    return resolve();
	  });
	};
	
	var removeBotFromLobby = exports.removeBotFromLobby = function removeBotFromLobby(_ref5) {
	  var commit = _ref5.commit,
	      state = _ref5.state;
	
	  return new _promise2.default(function (resolve, reject) {
	    if (state.player.hasBot === false) {
	      return reject();
	    }
	    commit(types.REMOVE_PLAYER_FROM_ROOM, {
	      name: 'bot',
	      room: 'lobby'
	    });
	    commit(types.DELETE_BOT);
	    return resolve();
	  });
	};
	
	var movePlayerToLobby = exports.movePlayerToLobby = function movePlayerToLobby(_ref6, player) {
	  var commit = _ref6.commit,
	      state = _ref6.state,
	      dispatch = _ref6.dispatch;
	
	  if (state.player.hasBot && (state.room.lobby.length + 1) % 2 !== 0) {
	    dispatch('removeBotFromLobby');
	  }
	  commit(types.REMOVE_PLAYER_FROM_ROOM, {
	    name: player,
	    room: 'pending'
	  });
	  commit(types.ADD_PLAYER_TO_ROOM, {
	    name: player,
	    room: 'lobby'
	  });
	};
	
	var movePlayerToPending = exports.movePlayerToPending = function movePlayerToPending(_ref7, player) {
	  var commit = _ref7.commit,
	      state = _ref7.state,
	      dispatch = _ref7.dispatch;
	
	  if (state.player.hasBot && (state.room.lobby.length + 1) % 2 !== 0) {
	    dispatch('removeBotFromLobby');
	  }
	  commit(types.REMOVE_PLAYER_FROM_ROOM, {
	    name: player,
	    room: 'lobby'
	  });
	  if (player === 'bot') {
	    commit(types.DELETE_BOT);
	  } else {
	    commit(types.ADD_PLAYER_TO_ROOM, {
	      name: player,
	      room: 'pending'
	    });
	  }
	};
	
	var shuffleInLobby = exports.shuffleInLobby = function shuffleInLobby(_ref8, player) {
	  var commit = _ref8.commit,
	      state = _ref8.state,
	      dispatch = _ref8.dispatch;
	
	  if (state.room.lobby.length % 2 !== 0) {
	    if (state.player.hasBot === false) {
	      dispatch('addBotToLobby');
	    } else {
	      dispatch('removeBotFromLobby');
	    }
	  }
	  commit(types.SHUFFLE_PLAYER, {
	    room: 'lobby'
	  });
	};
	
	var swapPlayer = exports.swapPlayer = function swapPlayer(_ref9, payload) {
	  var commit = _ref9.commit,
	      state = _ref9.state,
	      dispatch = _ref9.dispatch;
	
	  commit(types.SWAP_PLAYER, payload);
	};

/***/ },

/***/ 61:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var playerInPending = exports.playerInPending = function playerInPending(state) {
	  return state.room.pending;
	};
	
	var playerInLobby = exports.playerInLobby = function playerInLobby(state) {
	  return state.room.lobby;
	};

/***/ },

/***/ 62:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(57);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _actions = __webpack_require__(60);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(61);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _map = __webpack_require__(63);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _room = __webpack_require__(65);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _player = __webpack_require__(64);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  actions: actions,
	  getters: getters,
	  modules: {
	    map: _map2.default,
	    room: _room2.default,
	    player: _player2.default
	  },
	  strict: debug
	});

/***/ },

/***/ 63:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  class: null,
	  text: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.CHANGE_MAP, function (state, _ref) {
	  var className = _ref.className,
	      text = _ref.text;
	
	  state.class = className;
	  state.text = text;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },

/***/ 64:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  list: {},
	  hasBot: false,
	  botName: '-- AI Elite --'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.CREATE_PLAYER, function (state, _ref) {
	  var name = _ref.name;
	
	  state.list[name] = {
	    name: name,
	    data: {
	      type: 'human'
	    }
	  };
	}), (0, _defineProperty3.default)(_mutations, types.UDPATE_PLAYER, function (state, _ref2) {
	  var name = _ref2.name,
	      data = _ref2.data;
	
	  for (var index in state.list) {
	    var player = state.list[index];
	    if (player.name === name) {
	      player.data = data;
	    }
	  }
	}), (0, _defineProperty3.default)(_mutations, types.DELETE_PLAYER, function (state, _ref3) {
	  var name = _ref3.name;
	
	  for (var index in state.list) {
	    var player = state.list[index];
	    if (player.name === name) {
	      delete state.list[name];
	    }
	  }
	}), (0, _defineProperty3.default)(_mutations, types.CREATE_BOT, function (state) {
	  state.list.bot = {
	    name: state.botName,
	    data: {
	      type: 'bot'
	    }
	  };
	  state.hasBot = true;
	}), (0, _defineProperty3.default)(_mutations, types.DELETE_BOT, function (state) {
	  delete state.list.bot;
	  state.hasBot = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _thirdParty = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  lobby: [],
	  pending: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_PLAYER_TO_ROOM, function (state, _ref) {
	  var room = _ref.room,
	      name = _ref.name;
	
	  state[room].push(name);
	}), (0, _defineProperty3.default)(_mutations, types.REMOVE_PLAYER_FROM_ROOM, function (state, _ref2) {
	  var room = _ref2.room,
	      name = _ref2.name;
	
	  for (var index in state[room]) {
	    var player = state[room][index];
	    if (player === name) {
	      state[room].splice(index, 1);
	    }
	  }
	}), (0, _defineProperty3.default)(_mutations, types.SHUFFLE_PLAYER, function (state, _ref3) {
	  var room = _ref3.room;
	
	  (0, _thirdParty.shuffle)(state[room]);
	  state[room] = state[room].filter(function () {
	    return true;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.SWAP_PLAYER, function (state, _ref4) {
	  var room = _ref4.room,
	      player1 = _ref4.player1,
	      player2 = _ref4.player2;
	
	  var player1Index;
	  var player2Index;
	  for (var index in state[room]) {
	    if (state[room][index] === player1) {
	      player1Index = index;
	    }
	    if (state[room][index] === player2) {
	      player2Index = index;
	    }
	  }
	  console.log(player1Index, player2Index, player1, player2);
	  (0, _thirdParty.swapArrayElements)(state[room], player1Index, player2Index);
	  state[room] = state[room].filter(function () {
	    return true;
	  });
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },

/***/ 66:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(72);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(57);
	
	var _thirdParty = __webpack_require__(38);
	
	var _player = __webpack_require__(36);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _map = __webpack_require__(37);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _data = {
	  showAddPlayer: false,
	  newPlayer: null,
	  lobbyAttrs: [],
	  luckyPlayer: null,
	  mapPreloader: []
	};
	
	exports.default = {
	  data: function data() {
	    return _data;
	  },
	
	  name: 'app',
	  created: function created() {
	    var self = this;
	    _player2.default.loadData(function (players) {
	      for (var index in players) {
	        self.$store.dispatch('addNewPlayer', players[index]);
	      }
	    }, function () {});
	
	    for (var index in _map2.default) {
	      this.mapPreloader.push(_map2.default[index][2].bg_class);
	    }
	  },
	
	  computed: (0, _extends3.default)({
	    totalPlayerInLobbyText: function totalPlayerInLobbyText() {
	      return this.playerInLobby.length + ' ' + (this.playerInLobby.length > 1 ? 'Players' : 'Player');
	    },
	    totalPlayerInPendingText: function totalPlayerInPendingText() {
	      return this.playerInPending.length + ' ' + (this.playerInPending.length > 1 ? 'Players' : 'Player');
	    },
	    mapClass: function mapClass() {
	      return this.$store.state.map.class;
	    },
	    mapName: function mapName() {
	      return this.$store.state.map.text;
	    }
	  }, (0, _vuex.mapGetters)(['playerInPending', 'playerInLobby'])),
	  methods: {
	    openAddPlayer: function openAddPlayer() {
	      this.showAddPlayer = true;
	      var self = this;
	      _vue2.default.nextTick(function () {
	        self.$refs.addPlayerInput.focus();
	      });
	    },
	    preFillLobbyAttrs: function preFillLobbyAttrs() {
	      var forecastPlayer = this.playerInLobby.length + 1;
	      for (var index = this.lobbyAttrs.length; index < forecastPlayer; index++) {
	        this.lobbyAttrs[index] = {
	          class: ''
	        };
	      }
	    },
	    shuffleMap: function shuffleMap() {
	      this.$store.dispatch('shuffleMap');
	    },
	    movePlayerToLobby: function movePlayerToLobby(player) {
	      this.preFillLobbyAttrs();
	      this.$store.dispatch('movePlayerToLobby', player);
	      this.updateLobbyAttr(false);
	    },
	    movePlayerToPending: function movePlayerToPending(player) {
	      this.$store.dispatch('movePlayerToPending', player);
	      this.updateLobbyAttr(false);
	    },
	    kickAllFromLobby: function kickAllFromLobby(player) {
	      while (this.$store.state.room.lobby.length) {
	        var index = this.$store.state.room.lobby.length - 1;
	        this.$store.dispatch('movePlayerToPending', this.playerInLobby[index]);
	      }
	      this.updateLobbyAttr(false);
	    },
	    addPlayer: function addPlayer() {
	      var _this = this;
	
	      if (!this.newPlayer) {
	        this.showAddPlayer = false;
	        return;
	      }
	
	      if (this.newPlayer === 'bot' || this.newPlayer === this.$store.state.player.botName) {
	        window.alert('This name reserve for bot. Please use another name.');
	        this.newPlayer = '';
	        this.openAddPlayer();
	        return;
	      }
	
	      this.$store.dispatch('addNewPlayer', this.newPlayer).then(function () {
	        _this.showAddPlayer = false;
	      }).catch(function () {
	        window.alert('This player is exists. Please add another name');
	      });
	      this.newPlayer = '';
	    },
	    deletePlayer: function deletePlayer(event) {
	      if (window.confirm('Do you want to delete "' + event.target.innerText + '"? ')) {
	        this.$store.dispatch('deletePlayer', event.target.innerText);
	      }
	    },
	    updateLobbyAttr: function updateLobbyAttr(shuffled) {
	      if (shuffled === true) {
	        var teamLottery = [0, 1];
	        (0, _thirdParty.shuffle)(teamLottery);
	
	        for (var index in this.playerInLobby) {
	          if (index < this.playerInLobby.length / 2) {
	            if (teamLottery[0] === 1) {
	              this.lobbyAttrs[index].class = 'team_red';
	            } else {
	              this.lobbyAttrs[index].class = 'team_blue';
	            }
	          } else {
	            if (teamLottery[0] === 1) {
	              this.lobbyAttrs[index].class = 'team_blue';
	            } else {
	              this.lobbyAttrs[index].class = 'team_red';
	            }
	          }
	        }
	      } else {
	        for (var _index in this.playerInLobby) {
	          this.lobbyAttrs[_index].class = '';
	        }
	        this.luckyPlayer = null;
	      }
	
	      this.lobbyAttrs = this.lobbyAttrs.filter(function () {
	        return true;
	      });
	    },
	    shuffle: function shuffle() {
	      if (this.$store.state.player.hasBot === false && this.playerInLobby.length % 2 !== 0) {
	        this.preFillLobbyAttrs();
	      }
	      this.$store.dispatch('shuffleInLobby');
	      this.updateLobbyAttr(true);
	      this.shuffleMap();
	    },
	    swapWithBot: function swapWithBot() {
	      this.luckyPlayer = null;
	
	      var botTeam;
	      for (var index in this.playerInLobby) {
	        if (this.playerInLobby[index] === 'bot') {
	          botTeam = this.playerInLobby.length / 2 > index ? 'A' : 'B';
	        }
	      }
	
	      var currentMember = [];
	      for (var _index2 in this.playerInLobby) {
	        currentMember.push(this.playerInLobby[_index2]);
	      }
	
	      var migrate;
	      if (botTeam === 'A') {
	        migrate = currentMember.splice(currentMember.length / 2, currentMember.length / 2);
	      } else {
	        migrate = currentMember.splice(0, currentMember.length / 2);
	      }
	
	      (0, _thirdParty.shuffle)(migrate);
	      var hostHuman = migrate.splice(0, 1);
	      this.luckyPlayer = hostHuman[0];
	      this.$store.dispatch('swapPlayer', {
	        room: 'lobby',
	        player1: 'bot',
	        player2: this.luckyPlayer
	      });
	    }
	  },
	  components: {}
	};

/***/ },

/***/ 113:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 115:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(113)
	
	/* script */
	__vue_exports__ = __webpack_require__(66)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 116:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "container-fluid map-bg",
	    class: mapClass
	  }, [_h('div', {
	    staticClass: "row"
	  }, [_h('div', {
	    staticClass: "col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4 inner-container"
	  }, [_h('div', {
	    staticClass: "mapping noselect pointer"
	  }, [_h('h1', {
	    attrs: {
	      "id": "map"
	    }
	  }, [_s(mapName)])]), " ", _h('div', {
	    staticClass: "player-list"
	  }, [_h('h5', {
	    staticClass: "heading"
	  }, ["\n          Lobby\n          ", _h('span', {
	    staticClass: "pull-right",
	    attrs: {
	      "id": "span_player_in_lobby"
	    }
	  }, ["\n            " + _s(totalPlayerInLobbyText) + "\n          "])]), " ", _h('ul', {
	    staticClass: "list-group",
	    attrs: {
	      "id": "ul_lobby_room"
	    }
	  }, [_l((playerInLobby), function(player, index) {
	    return _h('li', {
	      staticClass: "list-group-item player",
	      class: lobbyAttrs[index].class,
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) return;
	          movePlayerToPending(player)
	        }
	      }
	    }, ["\n            " + _s($store.state.player.list[player].name) + "\n            ", ($store.state.player.list[player].name === luckyPlayer) ? _h('span', {
	      staticClass: "glyphicon glyphicon-star",
	      attrs: {
	        "style": "margin-left: 5px; color:orange; text-shadow:none;",
	        "title": "You are lucky player!"
	      }
	    }) : _e()])
	  })]), " ", _h('h5', {
	    staticClass: "heading"
	  }, ["Players\n\n          ", _h('span', {
	    staticClass: "pull-right",
	    attrs: {
	      "id": "span_player_in_lobby"
	    }
	  }, ["\n            " + _s(totalPlayerInPendingText) + "\n          "])]), " ", _h('ul', {
	    staticClass: "list-group",
	    attrs: {
	      "id": "ul_pending",
	      "style": "margin-bottom: 0px;"
	    }
	  }, [_l((playerInPending), function(player) {
	    return _h('li', {
	      directives: [{
	        name: "touch",
	        rawName: "v-touch:press",
	        value: (deletePlayer),
	        expression: "deletePlayer",
	        arg: "press"
	      }],
	      staticClass: "list-group-item player",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) return;
	          movePlayerToLobby(player)
	        }
	      }
	    }, [_s($store.state.player.list[player].name)])
	  })]), " ", _h('ul', {
	    staticClass: "list-group"
	  }, [(!showAddPlayer) ? _h('li', {
	    staticClass: "list-group-item add-player",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) return;
	        openAddPlayer($event)
	      }
	    }
	  }, ["\n            Add Player ...\n          "]) : _e(), " ", (showAddPlayer) ? _h('li', {
	    staticClass: "list-group-item add-player-form"
	  }, [_h('div', {
	    staticClass: "input-group"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (newPlayer),
	      expression: "newPlayer"
	    }],
	    ref: "addPlayerInput",
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Player Name"
	    },
	    domProps: {
	      "value": _s(newPlayer)
	    },
	    on: {
	      "keydown": function($event) {
	        if ($event.keyCode !== 13) return;
	        addPlayer($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        newPlayer = $event.target.value
	      }
	    }
	  }), " ", _h('div', {
	    staticClass: "input-group-btn"
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": addPlayer
	    }
	  }, [(this.newPlayer) ? _h('span', ["Add"]) : _e(), " ", (!this.newPlayer) ? _h('span', ["Close"]) : _e()])])])]) : _e()]), " ", _h('button', {
	    staticClass: "btn btn-primary btn-block btn-lg",
	    attrs: {
	      "id": "shuffle",
	      "disabled": $store.state.room.lobby.length < 1
	    },
	    on: {
	      "click": shuffle
	    }
	  }, ["\n          Shuffle\n        "]), " ", _h('button', {
	    staticClass: "btn btn-default btn-block",
	    attrs: {
	      "id": "swap_to_bot",
	      "disabled": $store.state.player.hasBot === false
	    },
	    on: {
	      "click": swapWithBot
	    }
	  }, ["\n          Swap AI Player\n        "]), " ", _m(0)]), " ", _h('div', {
	    staticClass: "row"
	  }, [_h('div', {
	    staticClass: "col-sm-6"
	  }, [_h('button', {
	    staticClass: "btn btn-default btn-block",
	    attrs: {
	      "id": "reset",
	      "disabled": $store.state.room.lobby.length < 1
	    },
	    on: {
	      "click": kickAllFromLobby
	    }
	  }, ["Clear Lobby"])]), " ", _h('div', {
	    staticClass: "col-sm-6"
	  }, [_h('button', {
	    staticClass: "btn btn-default btn-block",
	    on: {
	      "click": shuffleMap
	    }
	  }, ["Random Battleground"])])])]), " "]), " ", " ", _h('div', {
	    attrs: {
	      "style": "width:1px;height: 1px;overflow: hidden;opacity: 0;",
	      "id": "preloader"
	    }
	  }, [_m(1), " ", _l((mapPreloader), function(mapClassName) {
	    return _h('div', {
	      staticClass: "map-bg",
	      class: mapClassName
	    })
	  })])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('p', {
	    staticClass: "help-block text-center"
	  }, [_h('i', {
	    staticClass: "glyphicon glyphicon-info-sign"
	  }), " Press and hold on player name to delete"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "glyphicon glyphicon-star"
	  })
	}}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.411d3c059eca6d573df6.js